<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>010-59576010/6011
          <span class="glyphicon glyphicon-envelope"></span>bxet@bx-vision.cn
        </div>
       
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav  hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_white.png">
      </div>
     
     
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in $t('nav')"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
         <a href="javascript:void(0);"  v-if="item.children.length>0">
              {{item.name}}
              <span  class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i>
          </a>
          <router-link :to="item.path" v-else >
            {{item.name}}
           <i class="underline"></i>
          </router-link>
         
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n"  class="down_box">
              <a :href="i.path" v-if="i.type =='2'" target="_blank">{{i.name}}</a>
              <router-link :to="i.path" v-if="i.type != '2'">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>

      <div class="switch_box">
        <div :class="lang_number == '1'? 'tag active' : 'tag'" @click="langClick('中　文','zh','1')">中</div>
        <div :class="lang_number == '2'? 'tag active' : 'tag'" @click="langClick('한국어','en','2')">英</div>
      </div>
      
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_white.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in $t('nav')"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      lang:localStorage.getItem("lang_desc") || "中　文",
      lang_number:localStorage.getItem("lang_number") || "1",
      navIndex: '',
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
    };
  },
  watch: {
    //监听路由变化
    $route(index) {
     
      this.navIndex = index.meta.index;
      console.log(index.meta)
    }
  },
  created(){
    // console.log(this.$router)
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    langClick(msg,type,number){
      this.lang = msg
      localStorage.setItem("lang",type)
      localStorage.setItem("lang_desc",msg)
      localStorage.setItem("lang_number",number)
      window.location.reload()
    }
  }
};
</script>
<style scoped>
.switch_box{
  display: flex;
  align-items: center;
  width: 95px;
  height: 20px;
  color: #fff;
  float:right;
  border: 1px solid #474747;
  color: #1e73be;
  border-radius: 80px;  
  cursor: pointer;
}
.switch_box .tag{
  width: 50px;
  text-align: center;
}
.switch_box .active{
  color: #fff;
  height: 20px;
  line-height: 20px;
  background:#474747 ;
  border-radius: 80px;
  transition: .4s;
}

.dropdown-menu{
  min-width: 95.89px;
}
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  width: 90%;
  margin: auto;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  margin-right: 10%;
  width: 12%;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 100%;
}
/* 导航栏 导航容器 */
#header .header-nav .header-nav-wrapper {
  display: flex;
  margin-bottom: 0;
  margin-right: 5%;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  margin: 0 15px;
  padding: 0 10px;
  position: relative;
  height: 60px;
  line-height: 60px;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
  white-space:nowrap
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  min-width: 130px;
  top: 100%;
  left: 10px;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
  text-align: center;
}
#header .header-nav .header-nav-wrapper > li > dl a{
  /* min-width: 100%; */
  min-height: 37px;
  display: block;
  box-sizing: border-box;
  white-space:nowrap;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  height: 38px;
  line-height: 38px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
.down_box{
  position: relative;
}
.down_box:hover .last_down{
  display: block;
}
.last_down{
  position: absolute;
  top: 0;
  right: -150px;
  background: #fff;
  width: 150px;
  text-align: center;
  display: none;
}
.last_down .last_down_name{
  /* min-height: 37px; */
  /* border-bottom: 1px solid #ccc;
  box-sizing: border-box; */
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 60%;
    /* height: 45px; */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue